import FormWithOtpField from './FormWithOtpField';

export default FormWithOtpField;